import "../Css/dumpyard.css";
import "../Css/header2.css";
import React, { useEffect, useState } from "react";
import Prismic from "@prismicio/client";
import { Link } from "react-router-dom";
import Contact from "./contact";
import Footer from "./footer";
import Logo from "../Assets/logo_harshit.png";
import MobileMenu from "./menu";
import SEO from "./SEO";
import CaseStudyBrowseDrawer from "./CaseStudyBrowseDrawer";

function Dumpyard() {
  const [isLoading, setIsLoading] = useState(false);
  const [isWorkDrawerOpen, setIsWorkDrawerOpen] = useState(false);

  const apiEndpoint = "https://harshitsharma.prismic.io/api/v2";
  const accessToken =
    "MC5ZYUVtbXhNQUFETUFuODZN.77-977-9Ye-_ve-_vX8o77-977-977-977-977-9a--_ve-_ve-_ve-_ve-_ve-_vQITBF5h77-977-977-977-977-977-9TO-_vQ";
  const Client = Prismic.client(apiEndpoint, { accessToken });
  const [doc, setDocData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await Client.query(
          Prismic.Predicates.at("document.type", "dumpyard"),
          {
            orderings: "[my.dumpyard.order desc]",
          },
        );

        if (response) {
          setDocData(response.results[0].data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setIsLoading(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
        <SEO
          title="Archives"
          description="Explore Harshit Sharma's design archive — experiments, side projects, and earlier UX/UI work outside the main portfolio."
          path="/archives"
        />
        <nav className="hero-nav">
        <div className="nav-grid-lines">
          {Array.from({ length: 16 }).map((_, i) => (
            <div
              className="nav-line-cell"
              key={i}
              style={{ "--line-delay": `${i * 0.03}s` }}
            />
          ))}
        </div>

        <div className="hero-brand">
         <a href="/">
            {" "}
            <img src={Logo} alt="logo" className="hero-logo-icon" />
          </a>
          <div className="hero-nav-links">
            <a href="/archives">Archives</a>,
            <a href="/about">About</a>,
            <a href="#contact">Contact</a>
          </div>
        </div>

        <div className="hero-nav-info">
          <div className="info-block">
            <span>Currently Lead</span>
            <span>Product Designer @ MakseGroup</span>
          </div>
          <div className="info-block">
            <span>Based in</span>
            <span>Gurugram,India</span>
          </div>
        </div>
      </nav>
      <MobileMenu onOpenWork={() => setIsWorkDrawerOpen(true)} />
      <CaseStudyBrowseDrawer
        isOpen={isWorkDrawerOpen}
        onClose={() => setIsWorkDrawerOpen(false)}
      />

      <div className="archive-page">
        <div className="dumpyard-container">
          <div className="case-study-main">
            <div className="cs-header archive-header">
              <div className="cs-header-left">
                <Link to="/" className="cs-back-btn">
                  ← BACK
                </Link>

                <div className="cs-header-content-bottom">
                  <h1 className="cs-heading archive-title">Archives</h1>
                  <p className="archive-subtitle">
                    Projects and explorations worth mentioning
                  </p>
                </div>
              </div>

              <div className="cs-header-right">
                <div className="cs-detail-cell">
                  <div className="cs-detail-icon-label">
                    <span className="cs-detail-icon" role="img" aria-label="calendar">🗓️</span>
                    <span className="cs-detail-label">SPANNING</span>
                  </div>
                  <span className="cs-detail-value">2019 - Present</span>
                </div>
              </div>
            </div>
          </div>

          <p className="archive-lead-text">
            Things I made when no one was watching.
          </p>

          <div className="responsive-grid">
            {isLoading &&
              Array.from({ length: 4 }).map((_, i) => (
                <div className="images" key={`skeleton-${i}`}>
                  <div
                    className="skeleton"
                    style={{ width: "100%", height: 280 }}
                  />
                  <p className="dump-date">
                    <div
                      className="skeleton skeleton-text"
                      style={{ width: 60 }}
                    />
                  </p>
                </div>
              ))}

            {!isLoading &&
              doc?.dumpyard.map((e) => (
              <div className="images">
                {e.content_type === "Image" ? (
                  <div style={{ position: "relative" }}>
                    <img className="dump-image" src={e.image_url} alt={e.tag || ""} />
                    <div className="dump-pills">
                      {e?.link_check ? (
                        <a
                          className="dump-link"
                          href={e.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Link ↗
                        </a>
                      ) : null}
                    </div>

                    <p className="dump-date">
                      {e?.tags_check ? (
                        <div className="dump-tag">
                          <p>{e.tag}</p>
                        </div>
                      ) : null}
                      <span className="dump-year">
                        →{e.date || "2024"}←
                      </span>
                    </p>
                  </div>
                ) : (
                  <div style={{ position: "relative" }}>
                    <video
                      className="dump-video"
                      src={e.video_url}
                      muted
                      playsInline
                      loop="loop"
                      autoPlay="autoplay"
                    ></video>
                    <div className="dump-pills">
                      {e?.link_check ? (
                        <a
                          className="dump-link"
                          href={e.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Link ↗
                        </a>
                      ) : null}
                    </div>

                    <p className="dump-date">
                      {e?.tags_check ? (
                        <div className="dump-tag">
                          <p>{e.tag}</p>
                        </div>
                      ) : null}
                      <span className="dump-year">
                        →{e.date || "2024"}←
                      </span>
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <section id="contact">
        <Contact />
        <Footer />
      </section>
    </>
  );
}

export default Dumpyard;
